import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  to {
    opacity: 0;
  }
`;

export const FadeIn = styled.div`
  animation: ${fadeIn} 500ms ease forwards;
  opacity: 0;
`;

export const FadeOut = styled.div`
  animation: ${fadeOut} 500ms ease forwards;
  opacity: 0;
`;
